<template>
  <div>
    <v-text-field
      v-if="!booleanSelect"
      v-model="input"
      :label="label"
      :readonly="!!readonly"
      color="blue"
    />

    <v-select
      v-if="booleanSelect"
      v-model="input"
      :label="label"
      :readonly="!!readonly"
      :items="[
        { text: true, value: 1 },
        { text: false, value: 0 }
      ]"
      color="blue"
    />
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'UserInfo',
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    booleanSelect: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      input: this.value,
    };
  },
  watch: {
    input: _.debounce(async function inputChange(value) {
      if (this.onChange && !this.readonly) {
        this.onChange({
          name: this.name,
          value,
        });
      }
    }, 600),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/backend/UserInfo.vue